import React from 'react'
import { Container } from '@material-ui/core'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router'
import { connect } from 'react-redux'

import { formatUrl } from '../util/formatUtils'
import { selectProfile } from '../redux/modules/selectors'
import NewPageLayout from '../layouts/NewPageLayout'
import { selectUserTeam } from '../redux/selectors/userTeamSelectors'
import { locationRoute, rootRoute } from '../routes/routes'
import PageTeamMembers from './PageTeamMembers'
import PageTeamAccount from './PageTeamAccount'
import PageTeamPerks from './PageTeamPerks'

const isMemberAndNotManager = userTeam => userTeam?.team && !userTeam.team.manager
const isNotMember = userTeam => !userTeam?.team

function PageTeamAdmin({ profile, userTeam, isLoadingUserTeam }) {
  const { path } = useRouteMatch()

  if (isMemberAndNotManager(userTeam) && !isLoadingUserTeam) {
    return <Redirect to={rootRoute.path} />
  }

  if (isNotMember(userTeam) && !isLoadingUserTeam && profile) {
    return (
      <Redirect
        to={formatUrl(locationRoute.path, { locationId: profile.locationId }, [
          { key: 'createTeam', value: 'true' },
        ])}
      />
    )
  }

  return (
    <NewPageLayout>
      <Container maxWidth="md">
        <Switch>
          <Route exact path={path}>
            <Redirect to={`${path}/members`} />
          </Route>
          <Route exact path={`${path}/members`} component={PageTeamMembers} />
          <Route exact path={`${path}/perks`} component={PageTeamPerks} />
          <Route exact path={`${path}/account`} component={PageTeamAccount} />
        </Switch>
      </Container>
    </NewPageLayout>
  )
}

const mapStateToProps = state => {
  const profile = selectProfile(state)
  const userTeam = selectUserTeam(state)
  const { isLoadingUserTeam } = state.userTeam

  return {
    profile,
    userTeam,
    isLoadingUserTeam,
  }
}

export default connect(mapStateToProps)(PageTeamAdmin)
